/**
 * tpWorkbookParserClass.ts
 *
 * Dispatcher: routes workbook parsing to the correct class-specific parser.
 * Import this function instead of calling class-specific parsers directly.
 */

import { parseTPWorkbook }    from './tpWorkbookParser'
import { parseTPWorkbookABS } from './tpWorkbookParserABS'
import { parseTPWorkbookLR }  from './tpWorkbookParserLR'
import type { TPWorkbookResult } from './tpWorkbookParser'

export type TPClass = 'DNV' | 'ABS' | 'LR'

export async function parseTPWorkbookForClass(
  file: File,
  tpClass: TPClass
): Promise<TPWorkbookResult> {
  switch (tpClass) {
    case 'ABS': return parseTPWorkbookABS(file)
    case 'LR':  return parseTPWorkbookLR(file)
    default:    return parseTPWorkbook(file)   // DNV
  }
}
